import { FC } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import type { PriceColor } from './Price';

type xMarginBadgeProps = Readonly<{ value: number; color: PriceColor }>;

export const XMarginBadge: FC<xMarginBadgeProps> = ({ value, color }) => {
  return (
    <div className={`badge badge-outline-${color} rounded-pill align-self-end py-1`}>
      <FormattedMessage id="dashboard.xMargin" />
      <span className="mx-1" data-e2e="xmargin">
        <FormattedNumber value={value} maximumFractionDigits={4} />
      </span>
      <span>%</span>
    </div>
  );
};

XMarginBadge.displayName = 'XMarginBadge';
